<template>
  <div id="sov">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>

    <div class="datepickerwrap card" style="flex-direction: row">
      <div class="leftcontent wrapitem d-flex">
        <div class="custom_dropdown customMultiselect mr-3">
          <select @change="siteDeviceChange" v-model="selected_website" class="form-control text-uppercase">
            <option value="https://www.hp.com/in-en">HP India</option>
            <option value="https://www.hp.com/in-en#commercial">Commercial HP India</option>
          </select>
        </div>
        <div class="datebox">
          <select v-model="device" @change="siteDeviceChange" class="form-control text-uppercase">
            <option value="laptop">Laptop</option>
          </select>
        </div>
        <div class="datebox custom_dropdown">
          <div @click="showProductModal" class="custom_dropdown_wrap" style="
           background: white;
           padding-left: 14px;
           border: 1px solid var(--base_color-40);
           border-radius: 5px;
           margin-left: -5px;
           padding-right: 14px;
           height: 2.2rem;
         ">
            <span class="custom_dropdown_title" style="
                margin-top: 0px;
                float: left;
                font-size: 12px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 201px;
              ">{{ selectedProduct.key }} &nbsp;</span>
            <i style="font-size: 17px;" class="fa fa-angle-down"></i>
            <!-- <select @change="refreshReview" v-model="selectedProduct" class="form-control text-uppercase">  
                <option value="all">All</option>           
                <option v-for="(d,i) in productOptions" :key="i" :value="d">{{d}}</option>
              </select> -->
          </div>
        </div>
        <div class="datebox">
          <datepicker placeholder="From" @input="refreshReview" v-model="reviewStartDate" />
        </div>
        <div class="datebox">
          <datepicker v-model="reviewEndDate" class="picker-left" placeholder="To" @input="refreshReview" />
        </div>
      </div>
      <div class="righcontent wrapitem">
        <button @click="backToSov" style="float: right" class="btn navigationButton" type="button">
          <img src="Icons_SVG/Arrow_Left.svg" height="16" class="backIcon" style="margin-top: -3px" />
          <span style="font-size:16px"> Back</span>
        </button>

      </div>
    </div>
   
    <div class="daterpickerwrap">
      <div class="">
        <div>
          <div style="display: flex">
            <div class="card w-50" style="margin: 10px; height: 100%">
              <h4 style="max-width: 50%; margin-bottom: 0px !important" class="graphHeading">
                Reviews and Rating
              </h4>
            </div>
            <div class="card w-50" style="margin: 10px; height: 100%">
              <h4 style="max-width: 50%; margin-bottom: 0px !important" class="graphHeading">
                Sentiments
              </h4>
            </div>
          </div>
          <div style="display: flex">
            <div class="card w-50" style="margin: 10px; height: 600px; overflow-y: auto">

              <div v-if="reviewStarData.length" no-body>
                <div class="pb-0 d-flex justify-content-center align-items-center justify-content-stretch mb-3 mt-2">
                  <div class="d-flex flex-column align-items-center w-30 mx-2 px-5">
                    <h4 class="mb-0" style="color: var(--green); font-size: 2rem; font-weight: 600">
                      <span>{{ reviewStarData[0].count | format }} </span>
                    </h4>
                    <p class="text-capitalize" style="
              color: var(--primary_brand);
              font-size: 1rem;
              margin-top: 30px;
            ">Total Reviews</p>

                  </div>

                </div>
              </div>

              <div v-if="reviewStarData[0]">
                <h5 class="text-capitalize mb-2">
                  <span style="
              max-width: 82%;
              display: inline-block;
              color: var(--primary_brand);
            "> {{ reviewStarData[0].product_name }} </span>
                  <i class="fa fa-star text-star-color float-right"></i>
                  <span class="float-right">{{ reviewStarData[0].review_avg | format }}</span>
                </h5>
                <div class="borderBetween"></div>
                <div class="progress-group" :key="i" v-for="(r, i) in reviewStarData[0].ratings">
                  <div class="progress-group-header">
                    <i class="fa fa-star text-star-color" :key="j" v-for="(s, j) in r.rating"></i>
                    <span class="ml-auto " style="margin-bottom: -0.3rem"> {{ r.count | format }}
                      <span class="text-muted small">({{ r.per | format }}%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars" style="margin-top: 0.2rem">
                    <div class="progress progress-xs" style="height: 0.5rem">
                      <div role="progressbar" class="progress-bar"
                        style="background-color: var(--green-80); border-radius: 1rem" :style="'width:' + r.per + '%'">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card w-50" style="margin: 10px; height: 600px; overflow-y: auto">
              <div class=" mt-1">
                <table class="table  table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Keyword</th>
                      <th scope="col">Positive Frequency</th>
                      <th scope="col">Negative Frequency</th>
                      <th scope="col">Total Frequency</th>
                      <th scope="col">Score</th>
                    </tr>
                  </thead>
                  <tbody style="font-size: 13px;">
                    <tr v-for="d in sentimentData" :key="d.word">
                      <td>
                        <span @click="openModal(d.word, '')" style="color:#20a8d8;cursor:pointer"> {{ d.word }}</span>
                      </td>
                      <td>
                        <div style="color: var(--green)">{{ d.positive_frequency }}</div>
                      </td>
                      <td>
                        <div style="color: var(--red)">{{ d.negative_frequency }}</div>
                      </td>
                      <td>
                        <div>{{ d.positive_frequency + d.negative_frequency }}</div>
                      </td>
                      <td>
                        <div>
                          <div>
                            <highcharts style="
                          width: fit-content;
                          height: 88px;
                          margin: auto;
                          margin-top: 7px;
                        " :options="sentimentChart[d.word]"></highcharts>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="lg" :title="modalTitle" v-model="showModal">
      <div class="customdim" v-show="modalLoader">
        <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
      </div>
      <div class="leftcontent wrapitem">
        <div class="datebox">
          <datepicker placeholder="From" v-model="reviewStartDate" />
        </div>
        <div class="datebox">
          <datepicker v-model="reviewEndDate" class="picker-left" placeholder="To" />
        </div>
        <div class="datebox">
          <button @click="refreshModal" class="btn btn-block weavrpurple" type="button">
            Submit
          </button>
        </div>
      </div>
      <b-card style="margin-top:10px">
        <div class="cust-head" style="">
          <h4 style="display:inline-block;padding-top:10px;text-transform:capitalize"> {{ chartDataMapper[chartDataKey]
            }} </h4>
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
            <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons button-variant="outline-secondary"
              @change="getKeywordChartData" v-model="interval" name="radiosBtn">
              <b-form-radio class="mx-0" value="month">Month</b-form-radio>
              <b-form-radio class="mx-0" value="week">Week</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
          <span class="float-right">
            <select class="customselect" @change="processChartData" v-model="chartDataKey">
              <option value="original_frequency">Frequency</option>
              <option value="original_score">Score</option>
              <option value="reviews_count">Review Count</option>
            </select>
          </span>
        </div>
        <highcharts :options="modalChart" v-if="activeModalChart"></highcharts>
        <highcharts :options="cmodalChart" v-if="activeModalChart"></highcharts>
        <div v-if="!activeModalChart">No data</div>
      </b-card>
      <div class="datebox" style="width: unset!important;">
        <button :class="{ 'highlight_primary': modalSentimentType == '' }" @click="changeSentimentType('')"
          class="btn btn-primary" style="border-radius: 0; margin-right: 5px;">All</button>
        <button :class="{ 'highlight_success': modalSentimentType == 'positive' }"
          @click="changeSentimentType('positive')" class="btn btn-success "
          style="border-radius: 0; margin-right: 5px;">Positive</button>
        <button :class="{ 'highlight_danger': modalSentimentType == 'negative' }"
          @click="changeSentimentType('negative')" class="btn btn-danger "
          style="border-radius: 0; margin-right: 5px;">Negative</button>
      </div>
      <div class="reviews-panel">
        <div v-for="d in modalData.data" class="each-review">
          <div class="usericon">
            <i class="fa fa-user" style="font-size: 15px; color: silver;"></i>
          </div>
          <div class="username">
            {{ d.person_name }}
          </div>
          <div class="usertimestamp">
            {{ d.review_date }}
          </div>
          <div class="helpful">
            Helpful: {{ d.found_helpful }}
            <a :href="d.review_link" target="_blank">
              Link
            </a>
          </div>
          <div class="usertext">
            {{ d.review }}
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal size="lg" title="Select  " v-model="isProductModal" class="customModal">
      <b-row>
        <div class="col-md-12">
          <div style="display: flex" class="searchInput">
            <input style="border-radius: 0; padding: 6px; font-size: 11px" class="form-control" v-model="schProduct"
              type="text" placeholder="Search" />
            <div class="searchIcon">
              <img src="Icons_SVG/Search.svg" />
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="pt-2">
        <div class="col-md-12 mb-1" v-if="checkChannel()">
          <div class="row">
            <div class="col-md-2">
              <p class="mt-1 inputBoxTitle">OEM:</p>
            </div>
            <div class="col-md-10 customMultiselect">
              <select v-model="brandFilter" @change="changeFilter" class="form-control">
                <option value="">All</option>
                <option style="text-transform:capitalize" v-for="d in filterKeys.brand" :value="d" :key="d">{{
      d.replace('msi', 'MSI').replace('hp', 'HP') }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-1">
          <div class="row">
            <div class="col-md-2">
              <p class="mt-1 inputBoxTitle">Processor:</p>
            </div>
            <div class="col-md-10 customMultiselect">
              <select v-model="cpuFilter" @change="changeFilter" class="form-control fluid">
                <option value="">All</option>
                <option style="text-transform:capitalize" v-for="d in filterKeys.processor_type" :value="d" :key="d">{{
      d.replace('amd', 'AMD') }}</option>
              </select>
            </div>
          </div>
        </div>
      </b-row>
      <b-row>
        <div class="col-md-12 mb-1">
          <div class="row">
            <div class="col-md-1">
              <p class="inputBoxTitle">Ratings:</p>
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-3   ">
              <select v-model="ratingExp" class="form-control text-uppercase modalSelect">
                <option value="eq">Equals to (=)</option>
                <option value="gt">Greater than (&gt;)</option>
                <option value="gte">Greater than equals to (&gt;=)</option>
                <option value="lt">Lower than</option>
                <option value="lte">Lower than equals to (&lt;=)</option>
                <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
              </select>
            </div>
            <div class="col-md-2 pl-0">
              <input min="0" max="5" v-model="ratingInput1" style="border: 1px solid silver !important"
                class="form-control filval modalSelect" type="number" placeholder="Enter Value">

            </div>
            <div v-if="ratingExp == 'between'" class="col-md-2 pl-0">
              <input min="0" max="5" v-model="ratingInput2" style="border: 1px solid silver !important"
                class="form-control filval modalSelect" type="number" placeholder="Enter Value">

            </div>
            <div class="col-md-3 pl-0">
              <button @click="applyRatingFilter" class="btn primarycolor mr-1"> Apply </button>
              <button @click="removeRatingFilter" class="btn primarycolor" style="
              background-color: var(--red);
              padding-right: 7px;
              padding-left: 7px;
            "> Remove </button>
            </div>
          </div>
        </div>
      </b-row>
      <b-row style="margin-top: 15px; padding-right: 5px">
        <div class="col-md-3 pr-0">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="fourKSeries" type="checkbox"
              style="float: left; margin-right: 6px; margin-top: 3px">
            <span>4000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pl-1 pr-0">
          <div class="checkbox-btn">
            <input @change="changeFilter" v-model="fiveKSeries" type="checkbox"
              style="float: left; margin-right: 6px; margin-top: 3px">
            <span>5000 Series</span>
          </div>
        </div>

      </b-row>

      <div class="space-between-header" style="padding-top: 20px; align-items: center">
        <h6 class="m-0 graphHeading" style="margin-bottom: 0px !important">Products:</h6>
      </div>
      <div class="productScroll">
        <div :class="{ 'selectedProduct': selectedProduct.key == d.key }" v-if="checkSearchFilter(d.key)"
          class="eachProduct productListCheckbox" @click="selectProductNow(d)"
          style="padding: 6px; font-family: 'Poppins', sans-serif !important" :key="d" v-for="d in productOptions"> {{
      d.key }}

        </div>

      </div>
    </b-modal>
  </div>
</template>
<script>

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'


export default {
  name: 'sov',
  components: { Datepicker },
  data: function () {
    return {
      selected_website: 'https://www.hp.com/in-en',
      websitesUrls: {
        "https://www.hp.com/in-en": "hp_india",
        "https://www.hp.com/in-en#commercial": 'commercial_hp_india'
      },
      reviewStarData: [],
      sentimentData: {},
      sentimentChart: {},
      activeSentimentChart: false,
      selectedProduct: {},
      productOptions: [],
      reviewStartDate: moment().subtract(1, 'week').format('YYYY-MM-DD'),
      reviewEndDate: moment().format('YYYY-MM-DD'),
      loader: true,
      modalTitle: '',
      modalSentimentType: '',
      keywordChartData: {},
      showModal: false,
      modalLoader: false,
      chartDataKey: 'original_frequency',
      chartDataMapper: {
        'original_score': 'Score',
        'original_frequency': 'Frequency',
        'reviews_count': 'Reviews Count'
      },
      interval: 'month',
      activeModalChart: false,
      modalData: {},
      isProductModal: false,
      schProduct: '',
      deviceMapper: {
        'laptop': 'Laptop',
        'desktop': 'Desktop'
      },
      device: 'laptop',
      ratingInput1: '',
      ratingExp: 'eq',
      ratingInput2: '',
      pickProduct: false,
      filterChanged: false,
      cpuFilter: '',
      brandFilter: '',
      filterKeys: {
        brand: [],
        processor_type: []
      },
      reviewsRatingExp: 'eq',
      reviewsRatingInput: '',
      reviewsRatingInput2: '',
      reviewsData: {},
      updateSelectedProduct: false,
      fourKSeries: false,
      fiveKSeries: false,

    }
  },
  watch:
  {

    'revInterval': function () {
      if (this.selectedProduct.key)
        this.getReviews()
    }
  },
  mounted() {
    if (localStorage.cpuFilter) this.cpuFilter = localStorage.cpuFilter
    if (localStorage.brandFilter) this.brandFilter = localStorage.brandFilter
    if (localStorage.cpuFilter) this.cpuFilter = localStorage.cpuFilter
    if (localStorage.brandFilter) this.brandFilter = localStorage.brandFilter
    if (localStorage.ratingExp) this.ratingExp = localStorage.ratingExp
    if (localStorage.ratingInput1) this.ratingInput1 = localStorage.ratingInput1
    if (localStorage.ratingInput2) this.ratingInput2 = localStorage.ratingInput2
    if (localStorage.fourKSeries) this.fourKSeries = JSON.parse(localStorage.fourKSeries)
    if (localStorage.fiveKSeries) this.fiveKSeries = JSON.parse(localStorage.fiveKSeries)

    if (localStorage.reviewStartDate) {
      this.reviewStartDate = localStorage.reviewStartDate
      this.reviewEndDate = localStorage.reviewEndDate
    }
    else {
      this.reviewStartDate = moment().subtract(2, 'month').format('YYYY-MM-DD')
      this.reviewEndDate = this.date.startDate
    }
    this.getProducts()


  },
  methods: {
    siteDeviceChange() {
      let self = this
      self.updateSelectedProduct = true
      localStorage.selected_website = self.selected_website
      localStorage.selected_category = self.device

      self.getProducts()
    },
    removeRatingFilter() {
      this.ratingInput1 = ''
      this.ratingInput2 = ''
      if (localStorage.ratingExp) delete localStorage.ratingExp
      if (localStorage.ratingInput1) delete localStorage.ratingInput1
      if (localStorage.ratingInput2) delete localStorage.ratingInput2
      this.changeFilter()
    },
    applyRatingFilter() {
      let self = this
      if (self.ratingInput1 > 5) {
        alert('Rating value should be between 0 and 5')
        return false
      }
      if (self.ratingInput1 < 0) {
        alert('Rating value should be between 0 and 5')
        return false
      }
      if (self.ratingExp == 'between') {
        if (self.ratingInput2 > 5) {
          alert('Rating value should be between 0 and 5')
          return false
        }
        if (self.ratingInput2 < 0) {
          alert('Rating value should be between 0 and 5')
          return false
        }
      }
      self.changeFilter()
    },
    checkChannel() {
      if ((this.selected_website == 'https://www.amazon.com') || (this.selected_website == 'https://www.harveynorman.com.au') || (this.selected_website == 'https://www.costco.com') || (this.selected_website == 'https://www.walmart.com') || (this.selected_website == 'https://global.jd.com') || (this.selected_website == 'https://www.bestbuy.com') || (this.selected_website == 'https://www.currys.co.uk') || (this.selected_website == 'https://www.mediamarkt.de')) {
        return true
      }
      else {
        return false
      }
    },
    checkSearchFilter(d) {
      let self = this
      if (d.toLowerCase().indexOf(self.schProduct.toLowerCase()) != -1) {
        return true
      }
      else {
        return false
      }
    },
    changeFilter() {
      this.pickProduct = false
      this.filterChanged = true
      if (this.cpuFilter) localStorage.cpuFilter = this.cpuFilter
      else delete localStorage.cpuFilter
      if (this.brandFilter) localStorage.brandFilter = this.brandFilter
      else delete localStorage.brandFilter
      if (this.ratingExp) localStorage.ratingExp = this.ratingExp
      else delete localStorage.ratingExp
      if (this.ratingInput1) localStorage.ratingInput1 = this.ratingInput1
      else delete localStorage.ratingInput1
      if (this.ratingInput2) localStorage.ratingInput2 = this.ratingInput2
      else delete localStorage.ratingInput2
      if (this.fourKSeries) localStorage.fourKSeries = JSON.stringify(this.fourKSeries)
      else delete localStorage.fourKSeries
      if (this.fiveKSeries) localStorage.fiveKSeries = JSON.stringify(this.fiveKSeries)
      else delete localStorage.fiveKSeries
      this.filterActions()
    },
    selectProductNow(d) {
      let self = this
      self.selectedProduct = d
      self.refreshReview()
      self.isProductModal = false
    },
    showProductModal() {
      let self = this
      self.isProductModal = true
    },
    formatDate(key, d) {
      let self = this
      let obj = {
        'day': moment(d).format('MMM DD, YY'),
        'month': moment(d).format('MMM YY'),
        'week': ''
      }
      if (self[key] == 'week') {
        let end_date = moment(d).add(6, 'days')
        let today = moment(self.reviewEndDate)
        if (end_date >= today)
          end_date = today
        obj['week'] = moment(d).format('MMM DD, YY') + " - " + moment(end_date).format('MMM DD, YY')
      }
      return obj[this[key]]
    },
    backToSov() {
      window.location = "#/reviewlist-amd-india"
    },
    changeSentimentType(d) {
      this.$nextTick(function () {
        this.modalSentimentType = d
        this.getKeywordWiseData()
      })
    },
    getKeywordWiseData() {
      let self = this
      self.modalLoader = true
      self.loader = true
      let url = "/api/reviews/keywordwise"
      url += "?keyword=" + self.modalTitle
      url += "&product_name=" + self.selectedProduct.key

      url += "&channel=" + self.websitesUrls[self.selected_website]
      if (self.modalSentimentType)
        url += "&sentiment_type=" + self.modalSentimentType
      url += "&start_date=" + this.reviewStartDate + "&end_date=" + this.reviewEndDate
      console.log('here')
      self.$http.get(url).then(response => {
        self.modalData = response.body
        self.modalLoader = false
        self.loader = false
        if (!self.showModal) self.showModal = true
      }, err => {
        self.modalLoader = false
        self.loader = false
        console.log(err)
      });
    },

    processChartData() {
      let category = []
      let series = []
      let comm_series = []
      let datakeys = [{ key: 'positive', label: 'Positive', color: 'green' }, { key: 'negative', label: 'Negative', color: 'red' }]
      let self = this
      let new_key = ""
      let org_label = ""
      let com_label = ""
      if (this.chartDataKey == "original_frequency") {
        new_key = "frequency"
        org_label = "Frequency"
        com_label = "Cummulative Frequency"
      }
      else if (this.chartDataKey == "original_score") {
        new_key = "score"
        org_label = "Score"
        com_label = "Cummulative Score"
      }
      else {
        new_key = "cummulative_review_count"
        org_label = "Review Count"
        com_label = "Cummulative Review Count"
      }
      for (let [i, k] of datakeys.entries()) {
        if (this.keywordChartData.data[k.key]) {
          let obj = {}
          obj.name = k.label
          obj.data = []
          obj.color = k.color
          let comm_obj = {}
          let format_date = ""
          comm_obj.name = k.label
          comm_obj.data = []
          comm_obj.color = k.color
          for (let [idx, dataset] of this.keywordChartData.data[k.key].entries()) {

            category.push(self.formatDate('interval', dataset.date))
            obj.data.push(dataset[this.chartDataKey])
            comm_obj.data.push(dataset[new_key])
          }
          series.push(obj)
          comm_series.push(comm_obj)
        }
      }
      this.plotChart({ series: series, category: category }, 'modalChart', org_label)
      this.plotChart({ series: comm_series, category: category }, 'cmodalChart', com_label)
    },
    plotChart(d, chartObj, chart_label) {
      var self = this
      console.log(d)
      if (d.category.length)
        self.activeModalChart = true
      else
        self.activeModalChart = false
      this[chartObj] =
      {
        credits: {
          enabled: false
        },
        chart: {
          height: 210
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },

        yAxis: {
          title: {
            text: chart_label
          }
        },
        xAxis: {
          categories: d.category,
          crosshair: true,
          crosshair: {
            color: 'rgba(166, 215, 238)',
            width: 2,
          }
        },
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + '<br/>';
            for (var i = 0; i < this.points.length; i++) {
              mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
              mytooltip += this.points[i].series.name
              mytooltip += ' : <b> ' + self.format(this.points[i].y) + '</b> <br/>';
            }
            return mytooltip;
          },
          shared: true
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              radius: 1.9
            }
          }
        },
        series: d.series
      }
    },
    refreshModal() {
      let self = this
      self.reviewStartDate = moment(self.reviewStartDate).format('YYYY-MM-DD')
      self.reviewEndDate = moment(self.reviewEndDate).format('YYYY-MM-DD')
      this.getKeywordChartData()
      this.getKeywordWiseData()
    },
    openModal(keyword, type) {
      this.modalTitle = keyword
      this.modalSentimentType = type
      this.refreshModal('datecomponent')
    },
    getKeywordChartData() {
      let self = this
      self.modalLoader = true
      self.loader = true
      self.$nextTick(function () {
        self.keywordChartData = {}
        let url = "/api/reviews/keywisesentdata?interval=" + self.interval
        url += "&keyword=" + self.modalTitle
        url += "&product_name=" + self.selectedProduct.key
        url += "&channel=" + self.websitesUrls[self.selected_website]
        if (self.modalSentimentType)
          url += "&sentiment_type=" + self.modalSentimentType

        url += "&start_date=" + this.reviewStartDate + "&end_date=" + this.reviewEndDate
        self.$http.get(url).then(response => {
          self.keywordChartData = response.body
          self.modalLoader = false
          self.loader = false
          self.processChartData()
        }, err => {
          self.modalLoader = false
          self.loader = false
        });
      })
    },
    drawGaugeChart(word, positive, negative) {
      let self = this
      let series = []
      let value1 = Number(positive)
      let value2 = Number(negative)
      if (value1 && value2) {
        let obj = {}
        obj.name = "Positive"
        obj.color = "#1ACF85";
        obj.y = value1
        series.push(obj)
        let obj2 = {}
        obj2.name = "Negative"
        obj2.color = "#FF786B";
        obj2.y = value2
        series.push(obj2)
      }
      else {
        if (!value1) {
          let obj = {}
          obj.name = "Negative"
          obj.color = "#FF786B";
          obj.y = value2
          series.push(obj)
          let obj2 = {}
          obj2.name = "other"
          obj2.color = "#B3B2B9";
          obj2.y = 100 - value2
          obj2.dataLabels = { enabled: false }
          series.push(obj2)
        }
        if (!value2) {
          let obj = {}
          obj.name = "Positive"
          obj.color = "#1ACF85";
          obj.y = value1
          series.push(obj)
          let obj2 = {}
          obj2.name = "other"
          obj2.color = "#B3B2B9";
          obj2.y = 100 - value1
          obj2.dataLabels = { enabled: false }
          series.push(obj2)
        }
      }
      this.sentimentChart[word] = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          margin: [0, 0, 0, 0],
          padding: [0, 0, 0, 0],
          height: 110,
          width: 180
        },
        title: {
          text: '',
        },
        credits: {
          enabled: false
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          formatter() {
            if (this.point.name == 'other') {
              return false
            }
            var mytooltip = ''
            // console.log(this.point)
            mytooltip += '<span style="color:' + this.point.color + '!important">\u25CF</span> '
            mytooltip += this.point.name
            mytooltip += ' : <b> ' + self.format(this.point.y) + '%</b> <br/>'
            return mytooltip;
          },
          
        },
        plotOptions: {
          series: {
            borderWidth: 0,
          },
          pie: {
            dataLabels: {
              enabled: true,
              distance: -15,
              format: '{point.y:.1f}',
              style: {
                fontSize: 11,
              },
              color: 'black'
            },
            showInLegend: true,
            startAngle: -90,
            endAngle: 90,
            size: '100%',
            center: ['50%', '57%'],
          }
        },
        legend: {
          enabled: false,
          itemStyle: {
            fontSize: 9,
            fontWeight: 1,
          }
        },
        series: [{
          type: 'pie',
          innerSize: '59%',
          data: series
        }]
      }
    },
    getSentiment() {
      let self = this
      self.loader = true
      let payload = {
        "product_name": [self.selectedProduct.key],
        "channel": [self.websitesUrls[self.selected_website]],
        "start_date": moment(self.reviewStartDate).format('YYYY-MM-DD'),
        "end_date": moment(self.reviewEndDate).format('YYYY-MM-DD'),
        "item_category": self.device,
      }
      const url = "/api/websites/review_sentiment"
      self.$http.post(url, payload).then(response => {
        self.loader = false
        self.sentimentData = response.body.table
        for (let [y, td] of response.body.table.entries()) {
          if (td.positive_score == null) {
            td.positive_score = 0
          }
          if (td.negative_score == null) {
            td.negative_score = 0
          }
          self.drawGaugeChart(td.word, td.positive_score, td.negative_score)
        }

      }, err => {
        self.loader = false
        console.log('err')
      });
    },
    getReviewsStar() {
      let self = this
      self.loader = true
      let payload = {
        "product_name": [self.selectedProduct.key],
        "channel": [self.websitesUrls[self.selected_website]],
        "start_date": moment(self.reviewStartDate).format('YYYY-MM-DD'),
        "end_date": moment(self.reviewEndDate).format('YYYY-MM-DD'),
        "item_category": self.device,
      }
      const url = "/api/websites/review_bulk"
      self.$http.post(url, payload).then(response => {
        self.loader = false
        self.reviewStarData = response.body.data
      }, err => {
        self.loader = false
        console.log('err')
      });
    },

    refreshReview() {
      let self = this
      localStorage.reviewStartDate = this.reviewStartDate
      localStorage.reviewEndDate = this.reviewEndDate
      if (self.selectedProduct.key) {
        self.getReviewsStar()
        self.getSentiment()
      }
    },
    getProducts() {
      let self = this
      self.loader = true
      self.productOptions = []
      self.productOptionsFull = []
      self.selectedProduct = {}
      const url = "/api/websites/website_products"
      let payload = {}
      payload["website"] = []
      payload["item_category"] = self.device
      payload['start_date'] = moment(self.reviewStartDate).format('YYYY-MM-DD')
      payload['end_date'] = moment(self.reviewEndDate).format('YYYY-MM-DD')

      if (self.selected_website == 'all') {
        for (let [idx, dataset] of Object.entries(self.websitesUrls)) {
          if (!self.oem_websites.includes(idx)) payload["website"].push(idx)
        }
      }
      else {
        payload["website"].push(self.selected_website)
      }
      self.$http.post(url, payload).then(response => {
        self.loader = false
        self.errorInProduct = false
        if (!response.body.data.length) {
          self.errorInProduct = true
          return
        }
        self.productOptionsFull = response.body.data.sort()
        self.filterKeys.brand = response.body.brand_list.sort()
        self.filterKeys.processor_type = response.body.processor_list.sort()
        console.log(localStorage)
        let selectedProductLocal = JSON.parse(localStorage.selected_product)
        if ((localStorage.selected_product) && (selectedProductLocal.key != 'all') && (!self.updateSelectedProduct))
          self.selectedProduct = JSON.parse(localStorage.selected_product)
        else {
          self.selectedProduct = self.productOptionsFull[8]
        }
        self.filterActions()

      }, err => {
        self.loader = false
        self.errorInProduct = true
        console.log('err')
      });
    },
    filterActions() {
      this.productOptions = []
      let brandCheck = true
      let cpuCheck = true
      let ratingCheck = true
      let seriesCheck = true

      let ratingExpMapper = {
        'eq': function (a, b) { return a == b },
        'gt': function (a, b) { return b > a },
        'gte': function (a, b) { return b >= a },
        'lt': function (a, b) { return b < a },
        'lte': function (a, b) { return b <= a },
        'between': function (a1, a2, b) { return ((b >= a1) && (b <= a2)) }
      }
      for (let [ii, rr] of this.productOptionsFull.entries()) {
        if (this.brandFilter)
          brandCheck = this.brandFilter == rr.brand_name
        if (this.cpuFilter)
          cpuCheck = this.cpuFilter == rr.processor_type
        if (this.ratingExp != 'between' && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1, rr.rating)
        else if (this.ratingExp == 'between' && this.ratingInput1 && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1, this.ratingInput2, rr.rating)

        if (this.fourKSeries && this.fiveKSeries)
          seriesCheck = (rr.processor_model[0] == '4') || (rr.processor_model[0] == '5')
        else if (this.fourKSeries && !this.fiveKSeries)
          seriesCheck = (rr.processor_model[0] == '4')
        else if (!this.fourKSeries && this.fiveKSeries)
          seriesCheck = (rr.processor_model[0] == '5')
        if (brandCheck && cpuCheck && ratingCheck && seriesCheck) {
          this.productOptions.push(rr)
        }
      }
      if (this.filterChanged) {
        self.selectedProduct = self.productOptions[0]
        localStorage.selected_product = JSON.stringify(self.selectedProduct)
      }
      this.refreshReview()
    },
    format(v) {
      return this.$options.filters.format(v)
    },
  }
}

</script>

<style scoped>
.selectedProduct {
  background: #8e8d8d !important;
  color: White !important;
}


.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.searchInput input {
  height: 35px !important;
  margin-right: -5px !important;
  font-size: 14px !important;
  border-color: var(--primary_brand-60) !important;
  font-family: "poppins";
}

.searchInput input::placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.searchInput input:focus {
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
  font-family: "poppins";
}

.searchIcon {
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  font-family: "poppins";
  background-color: var(--primary_brand);
}

.searchIcon img {
  width: 25px;
  margin: 10px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

.modalSelect {
  margin-bottom: 6px !important;
}

.inputBoxTitle {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}

.cardper {
  float: right;
  position: absolute;
  right: 11px;
  bottom: 0;
  font-size: 29px;
  color: white;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.borderBetween {
  border-bottom: 0.13rem solid #e1e1e1 !important;
  margin: 10px 0px 20px !important;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}

.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;

  padding-bottom: 5px;
}

.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}

.space-between-header h3 {
  color: #4e4e4e;
  margin-bottom: 0;
  line-height: 31px;
}

.datebox {
  width: 14% !important;
}

.custom_dropdown {
  text-transform: uppercase;
  -youbkit-touch-callout: none;
  /* iOS Safari */
  -youbkit-user-select: none;
  /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE 10+ and Edge */
  user-select: none;
}


.custom_dropdown_wrap {
  cursor: pointer;
  display: flex;
  border: 1px solid silver;
  background: white;
  justify-content: space-between;
  padding: 7px;
  height: 30px;
}

.custom_dropdown_title {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mycols:first-child {
  padding-right: 2px !important
}

.mycols:last-child {
  padding-left: 2px
}

.checkbox-btn {
  margin-right: 6px;
  height: 35px !important;
  display: flex;
  align-items: center;
  border: none;
  background-color: var(--base_color-10);
  border-radius: 5px;
  color: #000;
  padding: 0px 10px;
  font-family: "poppins";
}

.checkbox-btn span {
  padding: 0 5px;
  margin-left: 10px;
  font-family: "poppins";
}

.checkbox-btn input {
  margin: 4px;
  font-size: 11px;
  accent-color: #fff;
  width: 15px;
  height: 15px;
  font-family: "poppins";
}

.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px
}

.customselect {
  height: 34px;
  border-radius: 0;
  background: white;
  border: 1px solid silver;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
}

.eachProduct:hover {
  background: #d4d4d4;
}

.productListCheckbox {
  display: flex;
  align-items: center;
}

.productListCheckbox input {
  font-size: 11px !important;
  accent-color: var(--primary_brand);
  width: 15px !important;
  height: 15px !important;
}

.productListCheckbox input[type="checkbox"] {
  border: 1px solid var(--primary_brand) !important;
}

.productListCheckbox span {
  margin-left: 10px;
  /* font-weight: 600; */
  font-family: "Poppins", sans-serif !important;
}

.productScroll {
  padding-top: 0px;
  cursor: pointer;
  height: 300px;
  overflow-y: scroll;
}

table {
  --border: 1px solid var(--base_color-20);
  border-radius: 10px;
  border-spacing: 0;
  border-collapse: separate;
  border: var(--border);
  overflow: hidden;
}

table th:not(:last-child),
table td:not(:last-child) {
  border-right: var(--border) !important;
}

table>thead>tr:not(:last-child)>th,
table>thead>tr:not(:last-child)>td,
table>tbody>tr:not(:last-child)>th,
table>tbody>tr:not(:last-child)>td,
table>tfoot>tr:not(:last-child)>th,
table>tfoot>tr:not(:last-child)>td,
table>tr:not(:last-child)>td,
table>tr:not(:last-child)>th,
table>thead:not(:last-child),
table>tbody:not(:last-child),
table>tfoot:not(:last-child) {
  border-bottom: var(--border) !important;
}

table th {
  background: var(--background);
  padding: 0.6rem !important;
  font-size: 14px !important;
  font-family: "Poppins", sans-serif !important;
}

table td {
  padding: 4px !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}
</style>

<style lang="scss">
.modal-title {
  font-weight: 600 !important;
  font-family: "poppins";
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color);
  border: none;
  display: flex !important;
  justify-content: start !important;
  padding-bottom: 1rem !important;
  font-family: "poppins";
}

.modal-header .close {
  color: black;
  text-shadow: none;
  position: absolute;
  top: -2px;
  right: -6px;
  font-size: 30px;
  background: var(--primary_brand-10);
  opacity: inherit;
  padding: 5px 10px;
  border-radius: 25px;
}
</style>

<style>
.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

.customMultiselect .multiselect__input {
  border: var(--base_color-20) !important;
  height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
  outline: none !important;
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
  background-color: #44777A !important;
  color: white !important;
  font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
  font-size: 10px !important;
  padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}
